import { Injectable } from '@angular/core';
import { Firestore, collection, addDoc, query, where, getDocs, serverTimestamp } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ReferralService {
  constructor(
    private firestore: Firestore,
    private toastr: ToastrService
  ) {}

  /**
   * Kiểm tra xem email đã tồn tại trong hệ thống chưa
   */
  async checkEmailExists(email: string): Promise<boolean> {
    const userQuery = query(
      collection(this.firestore, 'User'),
      where('email', '==', email)
    );
    
    const userSnapshot = await getDocs(userQuery);
    return !userSnapshot.empty;
  }

  async sendInvitation(senderEmail: string, senderUid: string, friendEmail: string): Promise<boolean> {
    try {
      // Kiểm tra email đã tồn tại chưa
      const emailExists = await this.checkEmailExists(friendEmail);
      if (emailExists) {
        this.toastr.warning('Email này đã tồn tại trong hệ thống', 'Thông báo');
        return false;
      }
      
      // Lưu thông tin lời mời vào Firestore
      await addDoc(collection(this.firestore, 'invitations'), {
        senderEmail,
        senderUid,
        friendEmail,
        referralUid: senderUid, // Dùng senderUid làm mã giới thiệu
        status: 'pending',
        createdAt: serverTimestamp(),
      });
      
      this.toastr.success('Đã gửi lời mời thành công', 'Thành công');
      return true;
    } catch (error) {
      console.error('Error sending invitation:', error);
      this.toastr.error('Có lỗi xảy ra khi gửi lời mời', 'Lỗi');
      return false;
    }
  }
}
